import React from 'react';
import { MessageSquare, Sparkles } from 'lucide-react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import './AdvisingDashboard.scss';

/**
 * AdvisingDashboard - Refactored for High-Fidelity Text Reports
 * Focused on the "Ask Advisor" narrative output.
 */
const AdvisingDashboard = ({ data, question, transcript }) => {
  if (!data) return null;
  
  const finalReport = data.final_report || "";

  return (
    <div className="advising-dashboard narrative-only">
      <header className="dashboard-header">
        <div className="header-content">
          <span className="logo-icon"><Sparkles size={24} className="sparkle-icon" /></span>
          <h1>Intelligent Advisory Narrative</h1>
          <p>Institutional Curriculum Analysis & Strategic Pathway</p>
        </div>
      </header>

      {(question || transcript) && (
        <div className="inquiry-context">
          {question && (
            <div className="context-item question">
              <span className="context-label">Inquiry</span>
              <p className="context-value">{question}</p>
            </div>
          )}
          {transcript && transcript !== 'No transcript provided. Use institution assumptions.' && (
            <div className="context-item transcript">
              <span className="context-label">Source Context</span>
              <p className="context-value transcript-text">{transcript}</p>
            </div>
          )}
        </div>
      )}

      <div className="narrative-container">
        <div className="narrative-header">
          <MessageSquare size={20} />
          <span>Advisor's Strategic Intelligence Report</span>
        </div>
        
        <div 
          className="narrative-content"
          dangerouslySetInnerHTML={{ 
            __html: DOMPurify.sanitize(marked.parse(finalReport)) 
          }}
        />
      </div>

      <footer className="narrative-footer">
        <p>This report is generated using dynamic curriculum reasoning and institutional transfer data.</p>
      </footer>
    </div>
  );
};

export default AdvisingDashboard;
